'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var ArrowDownIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 5.000000)"><path d="M0 0L7 7"/><path d="M14 0L7 7"/></g></g></g>';
    case 'medium':
      return '<g stroke-width="1"><g stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 8.000000)"><path d="M0 0L14 14"/><path d="M28 0L14 14"/></g></g></g>';
    case 'large':
      return '<g stroke-width="1"><g stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(2.000000, 11.000000)"><path d="M0 1L22 22.88"/><path d="M44 1L22 22.87"/></g></g></g>';
    }
  }
});

module.exports = ArrowDownIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/ArrowDown.jsx
 **/